import { SVGProps } from 'react';
const HomeIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_40000002_15643)">
      <path
        d="M18.4863 10.3979L10.4414 2.35887C10.3835 2.30083 10.3147 2.25479 10.2389 2.22337C10.1632 2.19195 10.082 2.17578 10 2.17578C9.918 2.17578 9.83681 2.19195 9.76106 2.22337C9.68532 2.25479 9.61652 2.30083 9.55859 2.35887L1.51367 10.3979C1.2793 10.6323 1.14648 10.9507 1.14648 11.2827C1.14648 11.9722 1.70703 12.5327 2.39648 12.5327H3.24414V18.269C3.24414 18.6147 3.52344 18.894 3.86914 18.894H8.75V14.519H10.9375V18.894H16.1309C16.4766 18.894 16.7559 18.6147 16.7559 18.269V12.5327H17.6035C17.9355 12.5327 18.2539 12.4018 18.4883 12.1655C18.9746 11.6772 18.9746 10.8862 18.4863 10.3979Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_40000002_15643">
        <rect width="20" height="20" fill="white" transform="translate(0 0.534668)" />
      </clipPath>
    </defs>
  </svg>
);
export default HomeIcon;
